export { default as ComponentInspector } from './ComponentInspector';